/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Stack, Typography, Skeleton, Box, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const PolicyTotalHeader = ({ title, total, isLoading, isError, tooltip }) => {
	return (
		<Box
			sx={{
				height: '5em',
				padding: '1.25em',
				// marginTop: 5,
				justifyContent: 'center',
			}}
		>
			<Stack height='100%' justifyContent='center' alignItems='center'>
				{isLoading ? (
					<Skeleton variant='text' height={30} width={120} sx={{ mb: 1 }} />
				) : (
					<Typography
						variant='card_header'
						sx={{
							fontSize: '11px',
							display: 'inline-flex',
							alignItems: 'center',
							whiteSpace: 'nowrap',
							lineHeight: 1.2,
						}}
					>
						{title}
						{tooltip && (
							<Tooltip title={tooltip} placement='top' arrow>
								<InfoIcon
									sx={{
										fontSize: '14px',
										ml: 0.5,
										color: 'text.secondary',
										display: 'inline-flex',
									}}
								/>
							</Tooltip>
						)}
					</Typography>
				)}

				<Stack direction='row' justifyContent='center' alignItems='center' height='60px'>
					{isLoading ? (
						<Skeleton variant='text' height={40} width={60} />
					) : isError ? (
						<Typography color='error'>Failed to retrieve count</Typography>
					) : (
						<Typography variant='card_h4' sx={{ fontSize: '22px' }}>
							{total}
						</Typography>
					)}
				</Stack>
			</Stack>
		</Box>
	);
};

export default PolicyTotalHeader;
